import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import LinkIcon from "@mui/icons-material/Link";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 0.5,
};

const StyledCard = styled(Card)(({ theme }) => ({
  boxShadow: theme.shadows[5],
  borderRadius: theme.shape.borderRadius,
}));

export default function SignModal({ userId, onClose }) {
  const [adsData, setAdsData] = useState({
    slug: "",
    imageURL: "",
  });
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setError(null);

      try {
        const token = localStorage.getItem("token");

        if (!token) {
          throw new Error("Token not available. Please log in.");
        }

        const userResponse = await axios.get(
          `${API_BASE_URL}Ads/Find/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setAdsData({
          slug: userResponse.data.slug,
          imageURL: userResponse.data.imageURL,
        });
      } catch (err) {
        if (err.response?.status === 401) {
          try {
            const newToken = await refreshTokenIfNeeded();

            if (!newToken) {
              return navigate("/", { replace: true });
            }

            // إعادة الطلب بالتوكن الجديد
            const retryResponse = await axios.get(
              `${API_BASE_URL}Ads/Find/${userId}`,
              {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              },
            );

            setAdsData({
              slug: retryResponse.data.slug,
              imageURL: retryResponse.data.imageURL,
            });
          } catch (retryError) {
            setError("Retry failed: " + retryError.message);
          }
        } else {
          setError("Failed to fetch ads data");
        }
      }
    };

    fetchData();
  }, [userId]);

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <CardHeader
            dir="ltr"
            action={
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            }
            sx={{ textAlign: "center" }}
          />
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            {adsData.imageURL ? (
              <img
                src={adsData.imageURL}
                alt="Preview"
                style={{
                  width: "100%",
                  height: "70%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <Typography variant="body2">لا توجد صورة</Typography>
            )}
          </Box>

          <CardContent sx={{ textAlign: "right", mt: 2 }}>
            {error ? (
              <Typography color="error">{error}</Typography>
            ) : (
              <>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <LinkIcon sx={{ mr: 1, color: "#1976d2" }} />
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    <strong>اسم الرابط:</strong>{" "}
                    <strong>{adsData?.slug || "لايوجد"}</strong>
                  </Typography>
                </Box>
              </>
            )}
          </CardContent>
        </StyledCard>
      </Box>
    </Modal>
  );
}
